import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type SourceJobPayload = ApiRequestBody<typeof endpoints.jobSource, 'post'> & {
  jobId: string;
};

export const useSourceJobMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, ...body }: SourceJobPayload) => {
      return fetchClient.POST(endpoints.jobSource, {
        params: { path: { id: jobId } },
        body,
      });
    },
    // Sourcing commits Draft -> New before the worker later moves it to InProgress. Refresh lists, but do not
    // invalidate the detail: a refetch can observe intermediate New and clobber the caller's optimistic
    // InProgress patch (useJobEditSubmit).
    onSettled: () => {
      invalidateQuery(jobsQueryKeys.lists())();
    },
  });
};
